

<section class="home-content header-content">
  <article class="page-intro">
    <div class="container">
      <div class="text-align-virt">
        <div class="top-section">
          <H1>About us</H1>
        </div>
        <app-page-title [type]="type"></app-page-title>
      </div>
    </div>
  </article>

</section>
@if (editMode()) {
  <button class="button btn--edit"
    (click)="onAddItem()">
    Add Section
  </button>
}
@for (article of articles; track article; let i = $index) {
  @if (i%2 == 0) {
    <app-animated-article-left [article]="article"> </app-animated-article-left>
  }
  @if (i%2 == 1) {
    <app-animated-article-right [article]="article"> </app-animated-article-right>
  }
}